import type { Static } from 'runtypes';
import { Literal, Record, String } from 'runtypes';
import { CoreEventRuntype } from './core';
import { type BaseEvent, BaseEventRuntype } from './base';
import { BaseAiChatEventRuntype } from './ai-chat';
import { ClickstreamEventEnum } from 'bc-model';

const AiChatRequestedEventBrowserRuntype = BaseEventRuntype.And(BaseAiChatEventRuntype).And(
  Record({
    event: Literal(ClickstreamEventEnum.AI_ASSIST_REQUESTED),
    version: Literal(1),
  })
);

const AiChatRequestedEventServerRuntype = AiChatRequestedEventBrowserRuntype.And(
  CoreEventRuntype
).And(
  Record({
    sessionId: String,
  })
);

type AiChatRequestedBrowserEvent = Static<typeof AiChatRequestedEventBrowserRuntype>;
type AiChatRequestedServerEvent = Static<typeof AiChatRequestedEventServerRuntype>;

const isAiChatRequestedBrowserEvent = (obj: BaseEvent): obj is AiChatRequestedBrowserEvent => {
  return obj.event === 'AI Assist Requested';
};

const isAiChatRequestedServerEvent = (obj: BaseEvent): obj is AiChatRequestedServerEvent => {
  return obj.event === 'AI Assist Requested';
};

export {
  isAiChatRequestedBrowserEvent,
  isAiChatRequestedServerEvent,
  AiChatRequestedEventBrowserRuntype,
  AiChatRequestedEventServerRuntype,
  type AiChatRequestedBrowserEvent,
  type AiChatRequestedServerEvent,
};
